import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/app/dashboard/index')),
    redirect: '/app/dashboard',
    meta: {
      authRequired: true,
      agencyRequired: true
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/dashboard',
    name: 'dashboard',
    component: () => lazyLoadView(import('@views/app/dashboard/index')),
    meta: {
      authRequired: true,
      agencyRequired: true
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {}
    }),
  },
  {
    path: '/app/self-cv/general-data',
    name: 'self-cv',
    component: () => lazyLoadView(import('@views/app/self-cv/general-data')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_SELF_CV']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {}
    }),
  },
  {
    path: '/app/self-cv/curriculum',
    component: () => lazyLoadView(import('@views/app/self-cv/curriculum')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_SELF_CV']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/self-cv/apply-selection-process-list',
    component: () =>
      lazyLoadView(import('@views/app/selection-process/apply-list')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_SELF_CV']
    },    
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {}
    })
  },
  {
    path: '/app/candidate/general-data/:id?',
    name: 'general-data',
    component: () => lazyLoadView(import('@views/app/candidate/general-data')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_CANDIDATE_AGENCY']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/candidate/curriculum/:id',
    component: () =>
      lazyLoadView(import('@views/app/candidate/curriculum-list')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_CANDIDATE_AGENCY']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/selection-process',
    component: () =>
      lazyLoadView(import('@views/app/selection-process/index')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_SELECTION_PROCESS']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },  
  {
    path: '/app/selection-process/project',
    name: 'projeto',
    component: () =>
      lazyLoadView(import('@views/app/selection-process/projeto')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_SELECTION_PROJECT']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/selection-process-list',
    component: () =>
      lazyLoadView(import('@views/app/selection-process/list')),
    meta: {
      authRequired: false,
      agencyRequired: false
    },
    props: true,
  },  
  {
    path: '/app/settings-aoe',
    component: () => lazyLoadView(import('@views/app/settings/areas_expertise')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_CONFIG_AGENCY']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/settings-users',
    component: () => lazyLoadView(import('@views/app/settings/users')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_USER_AGENCY']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/settings-fields',
    component: () => lazyLoadView(import('@views/app/settings/fields')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_CONFIG_AGENCY']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/search-candidate/:id?',
    name: 'search-candidate',
    component: () => lazyLoadView(import('@views/app/search/search')),
    meta: {
      authRequired: true,
      agencyRequired: true,
      routeRoles: ['F_SEARCH', 'NOVA_FUNCAO']
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/app/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/app/settings/profile')),
    meta: {
      authRequired: true,
      agencyRequired: true
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      agency: store.state.auth.currentAgency || {},
    }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forgetPassword',
    component: () => lazyLoadView(import('@views/login/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/new-password/:token',
    name: 'newPassword',
    component: () => lazyLoadView(import('@views/login/newPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/load-agency',
    name: 'loadAgency',
    component: () => lazyLoadView(import('@views/login/loadAgency')),
    meta: {
      authRequired: true,
      agencyRequired: false
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      agencyRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')

        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    props: true,
  },
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
